import React from 'react';
import { Space, Typography } from 'antd';
import { DashboardRefreshButton, DashboardSearchInput } from '../components/dashboard';

const { Text } = Typography;

export default function ForkliftListControls({
  loading,
  onRefresh,
  search,
  setSearch,
  shownCount,
  totalActiveLiftCount,
}) {
  return (
    <div className="customer-preview-table-toolbar">
      <div className="customer-preview-table-toolbar-copy">
        <Text type="secondary" className="customer-preview-helper-text">
          Select a Unit ID to view service records.
        </Text>
        <Text type="secondary" className="customer-preview-table-count">
          Showing {shownCount} of {totalActiveLiftCount} active lifts
        </Text>
      </div>
      <Space wrap className="customer-preview-table-controls">
        <DashboardSearchInput
          value={search}
          onChange={(event) => setSearch(event.target.value)}
          placeholder="Search forklifts"
          className="customer-preview-search"
        />
        <DashboardRefreshButton loading={loading} onClick={onRefresh} />
      </Space>
    </div>
  );
}
